<div class="menuTriger" id="headTriger">
    <a mdbBtn floating="true" size="sm" gradient="blue" mdbWavesEffectj (click)="showHeader()">
        <i class="fa fa-arrow-up" id="headTrigerIcon"></i>
    </a>
</div>
<div class="row">
    <div class="col-md-1"></div>
    <div class="col-md-2 my-1">
        <mdb-card class="z-depth-2" borderColor="border-danger">
            <mdb-card-body>
                <div class="row total-box">
                    <div class="col-md-12 text-center">
                        <span class="total-box-header">UnEngaged</span>
                    </div>
                    <div class="col-md-12 text-center">
                        <span class="text-danger total-box-body">{{totalNotEngaged}}</span>
                    </div>
                </div>
            </mdb-card-body>
        </mdb-card>
    </div>
    <div class="col-md-2 my-1">
        <mdb-card class="z-depth-2" borderColor="border-danger">
            <mdb-card-body>
                <div class="row total-box">
                    <div class="col-md-12 text-center">
                        <span class="total-box-header">Total</span>
                    </div>
                    <div class="col-md-12 text-center">
                        <span class="text-danger total-box-body">{{totalTime}}</span>
                    </div>
                </div>
            </mdb-card-body>
        </mdb-card>
    </div>
    <div class="col-md-2 my-1">
        <mdb-card class="z-depth-2" borderColor="border-danger">
            <mdb-card-body>
                <div class="row total-box">
                    <div class="col-md-12 text-center">
                        <span class="total-box-header">Regular</span>
                    </div>
                    <div class="col-md-12 text-center">
                        <span class="text-danger total-box-body">{{totalRegularTime}}</span>
                    </div>
                </div>
            </mdb-card-body>
        </mdb-card>
    </div>
    <div class="col-md-2 my-1">
        <mdb-card class="z-depth-2" borderColor="border-danger">
            <mdb-card-body>
                <div class="row total-box">
                    <div class="col-md-12 text-center">
                        <span class="total-box-header">Overtime</span>
                    </div>
                    <div class="col-md-12 text-center">
                        <span class="text-danger total-box-body">{{totalOvertime}}</span>
                    </div>
                </div>
            </mdb-card-body>
        </mdb-card>
    </div>
    <div class="col-md-2 my-1">
        <mdb-card class="z-depth-2" borderColor="border-danger">
            <mdb-card-body>
                <div class="row total-box">
                    <div class="col-md-12 text-center">
                        <span class="total-box-header">Double Time</span>
                    </div>
                    <div class="col-md-12 text-center">
                        <span class="text-danger total-box-body">{{totalDoubleTime}}</span>
                    </div>
                </div>
            </mdb-card-body>
        </mdb-card>
    </div>
</div>
<div *ngIf='(viewEOSState$ | async) as e'>
    <div class="row">
        <div class="col-md-3 my-4" *ngFor="let item of e.Items">
            <mdb-card cascade="true" narrower="true" class="z-depth-2 h-100 card-font">
                <div class="view view-cascade gradient-card-header narrower py-2 mx-4 mb-3 d-flex justify-content-between align-items-center"
                    [ngClass]="{'sucess-gradient':item.WarningLevel === 0 || !item.WarningLevel, 'young-passion-gradient':item.WarningLevel === 1}">
                    <h4><strong>{{item.DriverNumber}}<span *ngIf='item.DriverHandle'> -
                                {{item.DriverHandle}}</span></strong></h4>
                </div>
                <mdb-card-body class="card-body-top-pos card-body-bottom-space">
                    <mdb-card-text>
                        <div *ngIf='e.isNotFound && !e.isError'>
                            <div class="alert alert-success" role="alert">
                                <div class="text-center">
                                    <h3><strong>All Drivers are Engaged!</strong>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive" *ngIf='!e.isNotFound'>
                            <table class="table" mdbTable small="true">
                                <tbody>
                                    <tr>
                                        <td>Auto EOS:</td>
                                        <td class="font-weight-bold">{{item.IsAutoEOS === 1 ? 'Active' : 'N/A'}}</td>
                                        <td>Sent In:</td>
                                        <td class="font-weight-bold">
                                            {{item.IsAutoEOS === 1 ? item.AutoEOSTime === '00:00:00' ? 'Pending' : item.AutoEOSTime : 'N/A'}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold" colspan="4">{{item.Location}}</td>
                                    </tr>
                                    <tr>
                                        <td [ngClass]="{'text-danger font-weight-bold':item.WarningLevel === 1}">
                                            Duration:</td>
                                        <td class="font-weight-bold col-value"
                                            [ngClass]="{'text-danger':item.WarningLevel === 1}">{{item.DurationText}}
                                        </td>
                                        <td>Next Job In:</td>
                                        <td class="font-weight-bold col-value">
                                            {{item.DurationNextJobSeconds > 0 ? secondsToTime(item.DurationNextJobSeconds, 1) : 'N/A'}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <div class="progress" style="margin-top: 4px;">
                                                <div class="progress-bar bg-success"
                                                    [style.width.%]="getBarRegularWidth(item)">
                                                    <span
                                                        *ngIf='item.PayClockRegular > 0'>{{item.PayClockRegular / 60 | number : '.2-2'}}</span>
                                                </div>
                                                <div *ngIf='item.PayClockOvertime > 0' class="progress-bar bg-warning"
                                                    [style.width.%]="getBarOvertimeWidth(item)">
                                                    {{item.PayClockOvertime / 60 | number : '.2-2'}}
                                                </div>
                                                <div *ngIf='item.PayClockOvertimeDouble > 0'
                                                    class="progress-bar bg-danger"
                                                    [style.width.%]="getBarDoubleTimeWidth(item)">
                                                    {{item.PayClockOvertimeDouble / 60 | number : '.2-2'}}
                                                </div>
                                            </div>
                                        </td>
                                        <td class="font-weight-bold col-value">
                                            {{secondsToTime(item.PayClockTotal * 60, 0)}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </mdb-card-text>
                </mdb-card-body>
            </mdb-card>
        </div>
    </div>
</div>